import { render } from "./EditCaseIncident.vue?vue&type=template&id=75043659"
import script from "./EditCaseIncident.vue?vue&type=script&lang=js"
export * from "./EditCaseIncident.vue?vue&type=script&lang=js"
script.render = render

export default script